
import axios from "axios";


export default class ErrorsLogChecker{
    static KEY_NAME_ERROR_IDS = 'error_rec_ids_list'
    static KEY_NAME_ERR_DATE_CHECK_NOT_RUNNING  = 'errors_date_not_runnig_tasks'
    constructor(router) {
        this.router = router;
    }

    check_logs(){
        this.getLastErrors().then(data=>{
            let new_err_ids = data[0]
            let last_activity = data[2]
            console.log(new_err_ids)
            if ( this.isNewErrorsExists(new_err_ids, last_activity) ){

                //this.router.push('/logs-job-component')
            }

        });
    }

    getLastErrors(){
        return axios.get('/logs/logs-erros-records')
            .then(
                res=>{
                    let new_err_ids_full = res.data.map(el=>el['id']);
                    let old_ids = this.getLastViewedError()
                    let new_err_ids = new_err_ids_full.filter(el=> !old_ids.includes(el))

                    let last_activity_errors = res.data_not_running;
                    if ( !this.isNeed_LastDateCheckingNotRunnigTasks() ){
                        last_activity_errors = null
                    }

                    return [new_err_ids,new_err_ids_full,last_activity_errors ]
                }
            )
    }

    isNewErrorsExists(new_err_ids, last_activity){
        if (new_err_ids.length >0)
            return true
        if ( (last_activity) && (last_activity.length>0))
            return true
        return false

    }


    setLastViewErrosInStore(err_ids){
        localStorage.setItem(ErrorsLogChecker.KEY_NAME_ERROR_IDS,  JSON.stringify(err_ids) )
        localStorage.setItem(ErrorsLogChecker.KEY_NAME_ERR_DATE_CHECK_NOT_RUNNING, JSON.stringify(Date.now()))
    }
    getLastViewedError(){
        let ids = localStorage.getItem(ErrorsLogChecker.KEY_NAME_ERROR_IDS);
        if (!ids){
            ids = []
        }
        else{
            ids =  JSON.parse(ids)
        }

        return ids
    }

    isNeed_LastDateCheckingNotRunnigTasks(){
        let last_date = localStorage.getItem(ErrorsLogChecker.KEY_NAME_ERR_DATE_CHECK_NOT_RUNNING)
        const time_period4alert = 24*3600*1000// in milisconds
        let res = false
        if (last_date){
            last_date = JSON.parse(last_date)
            let delta_time = Date.now() - last_date
            if (delta_time >= time_period4alert ) res = true
        }
        return res
    }
}
